import React, { useState } from 'react';
import { Container, Box, Heading, Button } from '@chakra-ui/react';
import SiteInfo from '../components/SiteInfo';

// Mock site data for testing
const mockSite = {
  id: 'test-site-1',
  name: 'Test Megalithic Site',
  description: 'This is a test site for development purposes. It contains various megalithic structures and features that are typical of sites in the database.',
  mainImage: 'https://images.unsplash.com/photo-1564207550505-32a7278fd6f9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
  location: {
    address: 'Stonehenge, Wiltshire, England',
    coordinates: {
      lat: 51.178882,
      lng: -1.826215
    }
  },
  estimatedEra: 'Neolithic / Bronze Age',
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  createdBy: 'test-user',
};

// Mock media data for testing
const mockMedia = [
  {
    id: 'media1',
    url: 'https://images.unsplash.com/photo-1564207550505-32a7278fd6f9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    type: 'image',
    caption: 'Main view of the site',
    isMain: true,
    predictions: [
      { class: 'Standing Stone', confidence: 0.95, source: 'manual' },
      { class: 'Circle', confidence: 0.87, source: 'auto' }
    ]
  },
  {
    id: 'media2',
    url: 'https://images.unsplash.com/photo-1559562935-63dae5e1e8b4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    type: 'image',
    caption: 'Side view of the site',
    predictions: [
      { class: 'Standing Stone', confidence: 0.92, source: 'manual' }
    ]
  },
  {
    id: 'media3',
    url: 'https://images.unsplash.com/photo-1591461712364-5c8a11ff3b33?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    type: 'image',
    caption: 'Aerial view of the site',
    predictions: [
      { class: 'Circle', confidence: 0.89, source: 'auto' }
    ]
  }
];

const TestSiteInfo = () => {
  const [site, setSite] = useState(mockSite);
  
  const handleUpdate = (updatedSite) => {
    setSite(updatedSite);
    console.log('Site updated:', updatedSite);
  };

  return (
    <Container maxWidth="container.xl" py={8}>
      <Heading as="h1" mb={6}>Test Site Info Component</Heading>
      
      <SiteInfo 
        site={site} 
        media={mockMedia} 
        onUpdate={handleUpdate}
        onFeatureClick={(feature) => console.log('Feature clicked:', feature)}
      />
    </Container>
  );
};

export default TestSiteInfo;
